import { SurveyQuestionAnswerNonGroup } from '../types/Survey.type';

// A required sub-question counts as answered when it has an answer object — but
// for a multi-select, an empty selection must not satisfy the requirement, and
// for text (which streams up live as the patient types) an empty/whitespace
// value must not either.
export const isSubQuestionAnswered = (answer?: SurveyQuestionAnswerNonGroup): boolean => {
  if (!answer) return false;
  if (answer.type === 'checkbox') {
    return Array.isArray(answer.value) && answer.value.length > 0;
  }
  if (answer.type === 'input' || answer.type === 'textarea') {
    return typeof answer.value === 'string' && answer.value.trim().length > 0;
  }

  return true;
};
